import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncComponentRetry = () => {
  return /*#__PURE__*/_jsx(ErrorMessage, {
    illustrationProps: {
      width: '100'
    },
    title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "page-lib.asyncComponentUtils.reload.title"
    }),
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "page-lib.asyncComponentUtils.reload.message"
    })
  });
};
const getLoadingComponent = ({
  showLoading,
  containerStyles,
  skeletonComponent
}) => {
  if (skeletonComponent) {
    return () => skeletonComponent;
  }
  if (showLoading) {
    return ({
      pastDelay
    }) => {
      return pastDelay ? /*#__PURE__*/_jsx("div", {
        style: Object.assign({
          height: '100%'
        }, containerStyles),
        children: /*#__PURE__*/_jsx(LoadingSpinner, {
          minHeight: 300,
          layout: "centered"
        })
      }) : null;
    };
  }
  return () => null;
};
export const makeAsyncComponent = (loader, {
  containerStyles,
  showLoading = true,
  skeletonComponent
} = {}) => {
  return Loadable({
    ErrorComponent: () => {
      return /*#__PURE__*/_jsx("div", {
        style: {
          height: '100%'
        },
        children: /*#__PURE__*/_jsx(AsyncComponentRetry, {})
      });
    },
    LoadingComponent: getLoadingComponent({
      showLoading,
      containerStyles,
      skeletonComponent
    }),
    delay: 500,
    loader
  });
};